<div class="asset-section">
	<div class="section-title">FDM + Exceedances</div>

	@if (operations === undefined) {
		<div class="loading-status">
			<div class="logo-spin"></div>
			Loading operations...
		</div>
	}

	<ng-container>
		<div class="row">
			<label class="col-md-2 col-form-label-sm">Operation:</label>
			@if (operations && operations.length === 0) {
				<div class="col-md-6 col-form-label-sm">No operations found for this asset.</div>
			}
			@if (operations && operations.length > 0) {
				<div class="col-md-6">
					<select class="form-control form-control-sm op-list" [(ngModel)]="selectedOperation" (ngModelChange)="operationChange($event)"
						title="Showing {{ operations && operations.length >= RECENT_OPERATIONS_LIMIT ? 'latest ' + RECENT_OPERATIONS_LIMIT : 'all' }} operations{{ onlyExceedances ? ' with exceedances' : '' }}{{ showEmpty ? '' : ' with rotor turn time > 2 minutes or not known' }}">
						@for (operation of operations; track operation) {
							<option [ngValue]="operation" [class]="GetOpClass(operation)">
								{{operation | operationlabel : (fleet ? fleet.time_offset_hours : 0) : true : true}}
							</option>
						}
					</select>
				</div>
			}
			<div class="col-md-4">
				<label class="col-form-label">
					<input [(ngModel)]="onlyExceedances" (ngModelChange)="updateOperations()" type="checkbox">
					Only operations with exceedances
				</label>
				@if (api.user.support) {
					<div title="Show empty ops (SUPPORT ONLY)">
						<label class="col-form-label">
							<input [(ngModel)]="showEmpty" (ngModelChange)="updateOperations()" type="checkbox">
							Show empty operations
						</label>
					</div>
				}
			</div>
		</div>
		@if (selectedOperation) {
			<div>
				<div class="bubble-tabs">
					<a class="bubble-tab" routerLink="exceedances" routerLinkActive="selected">FDM + Exceedances</a>
					<a class="bubble-tab" routerLink="flight-playback" routerLinkActive="selected">Flight Playback</a>
				</div>
				<router-outlet (activate)="updateRouterOutlet($event)"></router-outlet>
			</div>
		}
	</ng-container>
</div>